// useBuildingUpdate.js
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBuilding as updateBuildingService } from "../services/updateBuildingService";
import { selectedBuilding } from "../../../../../redux/buildings/selectedBuildingSlice";
import { fetchBuildings } from "../../../../../redux/buildings/buildingsSlice";

const useBuildingUpdate = (updateList, { currentPage, rowsPerPage }) => {
  const dispatch = useDispatch();
  const selectedBuildingData = useSelector(selectedBuilding);
  const [formData, setFormData] = useState(selectedBuildingData ?? {});
  const [validationErrors, setValidationErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [autosaveStatus, setAutosaveStatus] = useState("");

  // Update the local form state if the selected building changes.
  useEffect(() => {
    if (selectedBuildingData) {
      setFormData(selectedBuildingData ?? {});
    }
  }, [selectedBuildingData]);

  // Validate the building form fields.
  const validateBuildingForm = (data) => {
    const errors = {};
    // if (!data.buildingAddress)
    //   errors.buildingAddress = "Building address is required";
    // if (!data.buildingCity) errors.buildingCity = "Building city is required";
    // if (!data.buildingState)
    //   errors.buildingState = "Building state is required";
    // if (!data.buildingZipCode)
    //   errors.buildingZipCode = "Building zip code is required";
    return errors;
  };

  // Handle the update – if autoSave is true, then extra UI actions (such as leaving edit mode) can be omitted.
  const handleUpdateBuilding = async (autoSave = false) => {
    setIsSubmitting(true);
    const errors = validateBuildingForm(formData);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      setIsSubmitting(false);
      return false;
    }
    try {
      const success = await updateBuildingService(
        formData.buildingID,
        formData
      );
      if (success) {
        dispatch(fetchBuildings({ currentPage, rowsPerPage }));
        if (!autoSave && typeof updateList === "function") {
          updateList();
        }
      }
      return success;
    } catch (error) {
      console.error("Error updating building:", error);
      setValidationErrors({ form: error.message });
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  // A small wrapper to distinguish between manual save and auto save.
  const handleSave = async (autoSave = false) => {
    const success = await handleUpdateBuilding(autoSave);
    return success;
  };

  return {
    formData,
    setFormData,
    validationErrors,
    isSubmitting,
    autosaveStatus,
    setAutosaveStatus,
    handleSave,
    setValidationErrors,
  };
};

export default useBuildingUpdate;
